import React from 'react';
import { Link } from 'react-router-dom';
import { useAOS } from '../../hooks/useExternalLibs';
import { useLanguage } from '../../contexts/LanguageContext';

const QualityAssurance = () => {
  // Initialize external libraries using custom hooks
  useAOS();
  
  // Get translation function
  const { t } = useLanguage();

  return (
    <div className="service-details-page">
      {/* Page Title */}
      <div className="page-title dark-background" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/Photo-Building/eid1.JPG)` }}>
        <div className="container position-relative">
          <h1>{t('qualityAssurance.pageTitle')}</h1>
          <nav className="breadcrumbs">
            <ol>
              <li><Link to="/">{t('qualityAssurance.breadcrumbHome')}</Link></li>
              <li><Link to="/">{t('qualityAssurance.breadcrumbServices')}</Link></li>
              <li className="current">{t('qualityAssurance.breadcrumbCurrent')}</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Service Details Section */}
      <section id="service-details" className="service-details section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="services-list">
                <Link to="/services/custom-manufacturing">{t('qualityAssurance.customManufacturing')}</Link>
                <Link to="/services/technical-support">{t('qualityAssurance.technicalSupport')}</Link>
                <Link to="/services/after-sales-service">{t('qualityAssurance.afterSalesService')}</Link>
                <Link to="/services/quality-assurance" className="active">{t('qualityAssurance.qualityAssurance')}</Link>
                <Link to="/services/research-development">{t('qualityAssurance.researchDevelopment')}</Link>
                <Link to="/services/global-supply-chain">{t('qualityAssurance.globalSupplyChain')}</Link>
              </div>
            </div>
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
              <div className="service-content text-center">
                <img src={`${process.env.PUBLIC_URL}/assets/img/building/building-ekk.png`} alt="Quality Assurance" className="img-fluid services-img mx-auto d-block" />
                <h3 className="text-center">{t('qualityAssurance.title')}</h3>
                <p className="text-center">
                  {t('qualityAssurance.description1')}
                </p>
                <p className="text-center">
                  {t('qualityAssurance.description2')}
                </p>
                <h4 className="text-center">{t('qualityAssurance.frameworkTitle')}</h4>
                <ul className="text-start">
                  {t('qualityAssurance.framework').map((item, index) => (
                    <li key={index}><i className="bi bi-check-circle"></i> <span>{item}</span></li>
                  ))}
                </ul>
                
                <h4 className="text-center">{t('qualityAssurance.testingTitle')}</h4>
                <p className="text-center">
                  {t('qualityAssurance.testingDescription')}
                </p>
                
                <div className="row gy-4 mt-4">
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('qualityAssurance.qualityStandards')}</h5>
                      <p>{t('qualityAssurance.qualityStandardsDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('qualityAssurance.inspectionTechnology')}</h5>
                      <p>{t('qualityAssurance.inspectionTechnologyDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('qualityAssurance.processControl')}</h5>
                      <p>{t('qualityAssurance.processControlDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('qualityAssurance.continuousImprovement')}</h5>
                      <p>{t('qualityAssurance.continuousImprovementDesc')}</p>
                    </div>
                  </div>
                </div>
                
                <h4 className="text-center">{t('qualityAssurance.certificationsTitle')}</h4>
                <p className="text-center">
                  {t('qualityAssurance.certificationsDescription')}
                </p>
                
                <h4 className="text-center">{t('qualityAssurance.customerQATitle')}</h4>
                <p className="text-center">
                  {t('qualityAssurance.customerQADescription')}
                </p>
                
                <h4 className="text-center">{t('qualityAssurance.supplierQATitle')}</h4>
                <p className="text-center">
                  {t('qualityAssurance.supplierQADescription')}
                </p>
                
                <div className="text-center">
                  <Link to="/contact" className="btn btn-primary">{t('qualityAssurance.learnMore')}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services Section */}
      <section id="related-services" className="related-services section">
        <div className="container">
          <div className="section-title" data-aos="fade-up">
            <h2>{t('qualityAssurance.relatedServicesTitle')}</h2>
            <p>{t('qualityAssurance.relatedServicesDescription')}</p>
          </div>
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-mountain-city"></i>
                </div>
                <h3>{t('qualityAssurance.customManufacturing')}</h3>
                <p>{t('qualityAssurance.customManufacturingDesc')}</p>
                <Link to="/services/custom-manufacturing" className="readmore stretched-link">{t('qualityAssurance.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-compass-drafting"></i>
                </div>
                <h3>{t('qualityAssurance.afterSalesService')}</h3>
                <p>{t('qualityAssurance.afterSalesServiceDesc')}</p>
                <Link to="/services/after-sales-service" className="readmore stretched-link">{t('qualityAssurance.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-helmet-safety"></i>
                </div>
                <h3>{t('qualityAssurance.researchDevelopment')}</h3>
                <p>{t('qualityAssurance.researchDevelopmentDesc')}</p>
                <Link to="/services/research-development" className="readmore stretched-link">{t('qualityAssurance.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QualityAssurance;